import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { mode } from 'utils';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export default i18n.use(initReactI18next).init({
  keySeparator: false,
  fallbackLng: 'fi',
  debug: mode.nonStrict(),
  resources: {},
  returnNull: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});
